import _ from 'lodash';
import { convertArrayToCSV } from 'convert-array-to-csv';
import GET_FDA_ORG_UNIT_PERFORMANCE_REPORT from '../queries/getFdaOrgUnitPerformanceReportQuery';
import GET_ORG_UNITS_PERFORMANCE_REPORT from '../queries/getOrgUnitPerformanceReportQuery';
import { PERFORMANCE_METRIC_STATUSES } from '../../shared/constants/checkpoint-performance-report-metric-enums';

const fetchData = async (orgUnitId, hasSharedPerformanceData) => {
  if (!orgUnitId) throw new Error('No Org Unit ID selected.');

  const apollo = require('../../../apollo/configureApollo').default();
  const result = await apollo.query({
    query: !hasSharedPerformanceData
      ? GET_ORG_UNITS_PERFORMANCE_REPORT
      : GET_FDA_ORG_UNIT_PERFORMANCE_REPORT,
    variables: {
      id: orgUnitId
    },
    fetchPolicy: 'cache-first'
  });

  if (result.error) throw new Error(result.error);

  return !hasSharedPerformanceData
    ? result.data.performanceOrgUnitReport
    : result.data.fdaPerformanceOrgUnitReport;
};

const prepareData = async queryData => {
  if (!queryData.AppraisalOrgUnits.length || !queryData.PerformanceItems.length) return [];

  const preparedData = [];

  queryData.PerformanceItems.forEach(pi => {
    const measurement = pi.MeasurementUnit || `${pi.Numerator} / ${pi.Denominator}`;
    const dataPoints = pi.CheckpointPerformanceItemDataPoints;
    const header = {
      Metric: 'Metric',
      Units: 'Units',
      Date: 'Date',
      UpperLimit: 'UpperLimit',
      LowerLimit: 'LowerLimit',
      Actual: 'Actual'
    };
    const emptyRow = {
      Metric: '',
      Units: '',
      Date: '',
      UpperLimit: '',
      LowerLimit: '',
      Actual: ''
    };
    const dataPointRows = _.chain(dataPoints)
      .map((dp, idx, array) => ({
        Metric: pi.MeasurementName,
        Units: measurement,
        Date: dp.Checkpoints.DataCollectionDate,
        Actual: dp.Actual,
        UpperLimit: getLimitValue(dp, idx, array, dp => dp.UpperLimit),
        LowerLimit: getLimitValue(dp, idx, array, dp => dp.LowerLimit)
      }))
      .sortBy(d => d.Date)
      .value();

    preparedData.push(...dataPointRows);

    preparedData.push(emptyRow);
    preparedData.push(emptyRow);
    preparedData.push(header);
  });
  preparedData.pop();

  return _.sortBy(preparedData, dr => dr.Id);
};

const getLimitValue = (dataPoint, currentIdx, performanceItemDataPoints, valueProvider) => {
  if (dataPoint.IsHidden) {
    return null;
  }

  if (dataPoint.Status === PERFORMANCE_METRIC_STATUSES.Update.Id) {
    return valueProvider(dataPoint);
  }

  if (currentIdx >= 1 && valueProvider(performanceItemDataPoints[currentIdx - 1]) !== null) {
    return valueProvider(performanceItemDataPoints[currentIdx - 1]);
  }

  return valueProvider(performanceItemDataPoints[0]);
};

export const getActualPerformanceReportCsvData = async (
  orgUnitId,
  gettingFdaSharedData = false
) => {
  const queryData = await fetchData(orgUnitId, gettingFdaSharedData);
  const data = await prepareData(queryData);
  return convertArrayToCSV(data);
};
